import React from 'react';
import './Recruit.css';

const Recruit: React.FC = () => {
  return (
    <div className="n-page n-recruit">
      <header className="n-page-header">
        <div className="container">
          <span className="n-page-eyebrow">WORK WITH US</span>
          <h1>RECRUIT</h1>
          <p>採用情報</p>
        </div>
      </header>
      <section className="n-page-body">
        <div className="n-page-content">
          <section className="n-recruit-intro" aria-labelledby="recruit-heading">
            <div>
              <span className="n-page-eyebrow">JOIN OUR TEAM</span>
              <h2 id="recruit-heading">身体を動かす楽しさを、<br />一緒に届けませんか。</h2>
            </div>
            <div className="n-recruit-copy">
              <p>
                ストレッチやオイルマッサージの経験を活かして、一緒に働きませんか。
                ご応募やご質問は、公式LINEのメッセージまたはSNSのDMからお問い合わせください。
              </p>
              <a className="n-recruit-cta" href="https://lin.ee/sPhllf4M" target="_blank" rel="noopener noreferrer">
                公式LINEにメッセージする <span aria-hidden="true">↗</span>
              </a>
            </div>
          </section>

          <section className="n-recruit-details" aria-labelledby="recruit-details-heading">
            <span className="n-page-eyebrow">APPLICATION</span>
            <h2 id="recruit-details-heading">募集要項</h2>
            <dl className="n-recruit-terms">
              <div><dt>雇用形態</dt><dd>業務委託</dd></div>
              <div><dt>勤務頻度</dt><dd>週1日から相談OK</dd></div>
              <div><dt>応募条件</dt><dd>ストレッチまたはオイルマッサージの経験がある方</dd></div>
              <div><dt>報酬目安</dt><dd>時間換算で約2,500〜6,000円</dd></div>
            </dl>
            <p className="n-recruit-note">報酬は経験や施術内容などにより異なります。詳細は公式LINEのメッセージまたはSNSのDMからお問い合わせください。</p>
          </section>
        </div>
      </section>
    </div>
  );
};

export default Recruit;
